import { useState, useEffect, useCallback } from "react";
import yalaImage from "../assets/vehicle.png";
import jeepImage from "../assets/yb (45).jpg";
import packageImage from "../assets/yb (21).jpg";
import packageImage2 from "../assets/yb (1).jpg";
import packageImage3 from "../assets/yb (2).jpg";
import packageImage4 from "../assets/yb (3).jpg";
import packageImage5 from "../assets/yb (4).jpg";
import { useNavigate, useLocation } from "react-router-dom";
import moment from "moment";
import Calendar from "react-calendar";
import Modal from "react-modal";
import { apiEndpoints, publicFetch } from "../config/api";
import { toast } from "react-toastify";
import basicImage from "../assets/yb (6).jpg";
import luxuryImage from "../assets/luxury.jpg";

const Packages = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Check if a package was passed from navigation
  const preSelectedPackage = location.state?.selectedPackage;

  // ========================================
  // STATE DECLARATIONS
  // ========================================
  
  // Booking form states
  const [reservationType, setReservationType] = useState("private");
  const [park, setPark] = useState("yala");
  const [block, setBlock] = useState("blockI");
  const [jeepType, setJeepType] = useState("basic");
  const [timeSlot, setTimeSlot] = useState("morning");
  const [guideOption, setGuideOption] = useState("driver");
  const [visitorType, setVisitorType] = useState("foreign");
  const [mealOption, setMealOption] = useState("without");
  const [vegOption, setVegOption] = useState("non-veg");
  const [includeEggs, setIncludeEggs] = useState(false);
  const [includeLunch, setIncludeLunch] = useState(false);
  const [includeBreakfast, setIncludeBreakfast] = useState(false);
  const [people, setPeople] = useState(1);
  const [privateDate, setPrivateDate] = useState(new Date());

  // Customer information states
  const [pickupLocation, setPickupLocation] = useState("");
  const [hotelWhatsapp, setHotelWhatsapp] = useState("");
  const [accommodation, setAccommodation] = useState("");
  const [passportNumber, setPassportNumber] = useState("");
  const [fullName, setFullName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [nicNumber, setNicNumber] = useState("");
  const [localContact, setLocalContact] = useState("");
  const [localAccommodation, setLocalAccommodation] = useState("");

  // Date and seat selection states
  const [showDatePopup, setShowDatePopup] = useState(false);
  const [showSeatPopup, setShowSeatPopup] = useState(false);
  const [sharedSelectedDate, setSharedSelectedDate] = useState(null);
  const [sharedSelectedSeat, setSharedSelectedSeat] = useState(null);
  const [sharedBookedSeats] = useState([]);
  const [showBookingSection, setShowBookingSection] = useState(false);
  const [privateAvailableDates, setPrivateAvailableDates] = useState([]);

  // 🆕 PACKAGE SELECTION STATES (FROM API)
  const [availablePackages, setAvailablePackages] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState(preSelectedPackage || null);
  const [showPackageSelector, setShowPackageSelector] = useState(!preSelectedPackage);
  const [packagesLoading, setPackagesLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const packagesPerPage = 6;

  // 🆕 FILTER STATES
  const [searchQuery, setSearchQuery] = useState("");
  const [filterPark, setFilterPark] = useState("all");
  const [filterType, setFilterType] = useState("all");
  const [sortBy, setSortBy] = useState("name");

  // 🆕 DYNAMIC MEAL ITEMS FROM API (NO HARDCODED MENU)
  const [breakfastMenuItems, setBreakfastMenuItems] = useState([]);
  const [lunchMenuItems, setLunchMenuItems] = useState([]);
  const [selectedBreakfastItems, setSelectedBreakfastItems] = useState([]);
  const [selectedLunchItems, setSelectedLunchItems] = useState([]);

  // 🆕 PRICING FROM API (NO HARDCODED PRICES)
  const [pricing, setPricing] = useState(null);

  // Loading states
  const [loading, setLoading] = useState(true);

  // Carousel state for hero background images
  const carouselImages = [
    packageImage,
    packageImage2,
    packageImage3,
    packageImage4,
    packageImage5,
  ];
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Auto-rotate carousel every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => 
        (prevIndex + 1) % carouselImages.length
      );
    }, 5000);

    return () => clearInterval(interval);
  }, [carouselImages.length]);

  // Park images mapping (only images are local, everything else from API)
  const parkImages = {
    yala: yalaImage

  };

  // ========================================
  const handlePackageSelect = useCallback(
    (pkg) => {
      console.log("📦 Package Selected:", pkg);

      setSelectedPackage(pkg);

      // Auto-fill booking form with package data
      setPark(pkg.park);
      if (pkg.block) setBlock(pkg.block);

      // 🆕 SET PRICING FROM PACKAGE (FROM API, NOT HARDCODED)
      setPricing({
        jeep: pkg.jeep,
        shared: pkg.shared,
        meals: pkg.meals || { breakfast: 5, lunch: 6 },
        guide: pkg.guide,
        tickets: pkg.tickets, // Ticket prices from API
      });

      // 🆕 SET MEAL ITEMS FROM PACKAGE (FROM API, NOT HARDCODED)
      if (pkg.mealOptions) {
        if (pkg.mealOptions.breakfast && Array.isArray(pkg.mealOptions.breakfast)) {
          setBreakfastMenuItems(pkg.mealOptions.breakfast);
          // Don't auto-select items - let user choose
          setSelectedBreakfastItems([]);
        } else {
          setBreakfastMenuItems([]);
          setSelectedBreakfastItems([]);
        }
        if (pkg.mealOptions.lunch && Array.isArray(pkg.mealOptions.lunch)) {
          setLunchMenuItems(pkg.mealOptions.lunch);
          // Don't auto-select items - let user choose
          setSelectedLunchItems([]);
        } else {
          setLunchMenuItems([]);
          setSelectedLunchItems([]);
        }
      } else {
        // Reset meal items if package has no meal options
        setBreakfastMenuItems([]);
        setLunchMenuItems([]);
        setSelectedBreakfastItems([]);
        setSelectedLunchItems([]);
      }

      // Set package type if available
      if (pkg.packageType) {
        if (pkg.packageType === "private" || pkg.packageType === "both") {
          setReservationType("private");
        } else if (pkg.packageType === "shared") {
          setReservationType("shared");
        }
      }

      // Set max capacity
      if (pkg.maxCapacity) {
        setPeople(Math.min(people, pkg.maxCapacity));
      }

      // Close package selector and show booking form
      setShowPackageSelector(false);
      toast.success(`${pkg.name} selected!`);
    },
    [
      people,
      setSelectedPackage,
      setPark,
      setBlock,
      setPricing,
      setBreakfastMenuItems,
      setSelectedBreakfastItems,
      setLunchMenuItems,
      setSelectedLunchItems,
      setReservationType,
      setPeople,
      setShowPackageSelector,
    ]
  );

  // ========================================
  // 🆕 FETCH PACKAGES FROM API
  // ========================================
  const fetchPackages = useCallback(async () => {
    setPackagesLoading(true);
    try {
      const response = await publicFetch(
        `${apiEndpoints.packages.base}?isActive=true`
      );
      const data = await response.json();

      console.log("📦 Fetched packages from API:", data);

      if (data.success && data.packages) {
        setAvailablePackages(data.packages);

        // If preSelectedPackage exists, find and set it
        if (preSelectedPackage) {
          const foundPackage = data.packages.find(
            (pkg) => pkg._id === preSelectedPackage._id
          );
          if (foundPackage) {
            handlePackageSelect(foundPackage);
          }
        }
      } else {
        toast.error("Failed to load packages");
      }
    } catch (error) {
      console.error("Error fetching packages:", error);
      toast.error("Error loading packages. Please refresh the page.");
    } finally {
      setPackagesLoading(false);
      setLoading(false);
    }
  }, [handlePackageSelect, preSelectedPackage]);

  // ========================================
  // 🆕 HELPER FUNCTIONS - USE DYNAMIC DATA FROM API
  // ========================================

  const getBreakfastMenu = () => {
    if (!breakfastMenuItems || breakfastMenuItems.length === 0) return [];
    
    return breakfastMenuItems.filter((item) => {
      if (vegOption === "veg") {
        return item.isVegetarian !== false;
      }
      return true;
    });
  };

  const getLunchMenu = () => {
    if (!lunchMenuItems || lunchMenuItems.length === 0) return [];
    
    return lunchMenuItems.filter((item) => {
      if (vegOption === "veg") {
        return item.isVegetarian !== false;
      }
      return true;
    });
  };

  // 🆕 GET TICKET PRICE FROM API (NO HARDCODED PRICES)
  const getTicketPrice = () => {
    if (!pricing || !pricing.tickets) {
      console.warn("⚠️ No pricing data available, using fallback");
      return visitorType === "foreign" ? 15 : 5; // Fallback only
    }
    return visitorType === "foreign"
      ? pricing.tickets.foreign
      : pricing.tickets.local;
  };

  // 🆕 FILTER AND SEARCH LOGIC
  const getFilteredPackages = () => {
    let filtered = [...availablePackages];

    // Search filter
    if (searchQuery) {
      filtered = filtered.filter(
        (pkg) =>
          pkg.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
          pkg.description.toLowerCase().includes(searchQuery.toLowerCase()) ||
          pkg.park.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    // Park filter
    if (filterPark !== "all") {
      filtered = filtered.filter((pkg) => pkg.park === filterPark);
    }

    // Type filter
    if (filterType !== "all") {
      filtered = filtered.filter(
        (pkg) => pkg.packageType === filterType || pkg.packageType === "both"
      );
    }

    // Sorting
    switch (sortBy) {
      case "price-low":
        filtered.sort((a, b) => a.jeep.basic.morning - b.jeep.basic.morning);
        break;
      case "price-high":
        filtered.sort((a, b) => b.jeep.basic.morning - a.jeep.basic.morning);
        break;
      case "name":
      default:
        filtered.sort((a, b) => a.name.localeCompare(b.name));
        break;
    }

    return filtered;
  };

  const filteredPackages = getFilteredPackages();

  // Pagination calculations
  const indexOfLastPackage = currentPage * packagesPerPage;
  const indexOfFirstPackage = indexOfLastPackage - packagesPerPage;
  const currentPackages = filteredPackages.slice(
    indexOfFirstPackage,
    indexOfLastPackage
  );
  const totalPages = Math.ceil(filteredPackages.length / packagesPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // ========================================
  // 🆕 CALCULATE TOTAL PRICE - USE API DATA (NO HARDCODED PRICES)
  // ========================================
  const calculateTotal = () => {
    if (!pricing) {
      console.warn("⚠️ No pricing available");
      return "0.00";
    }

    let total = 0;

    try {
      // Add base safari price
      if (reservationType === "private") {
        const jeepPrice = pricing.jeep[jeepType]?.[timeSlot] || 0;
        const guidePrice = pricing.guide[guideOption] || 0;
        total = jeepPrice + guidePrice;
      } else {
        // Shared safari base price per person
        const sharedPrice = pricing.shared[Math.min(people, 7)] || 0;
        total = sharedPrice * people;
      }

      // Add ticket price per person (FROM API)
      const ticketPrice = getTicketPrice();
      total += ticketPrice * people;

      // Add meal prices per person if meals are selected
      if (mealOption === "with") {
        if (includeBreakfast && selectedBreakfastItems.length > 0) {
          const breakfastTotal = getBreakfastMenu()
            .filter((item) => selectedBreakfastItems.includes(item.name))
            .reduce((sum, item) => sum + (item.price || 0), 0);
          total += breakfastTotal * people;

          // Add eggs if veg option and includeEggs is true
          if (vegOption === "veg" && includeEggs) {
            total += 1.5 * people; // This could also come from API
          }
        }

        if (includeLunch && selectedLunchItems.length > 0) {
          const lunchTotal = getLunchMenu()
            .filter((item) => selectedLunchItems.includes(item.name))
            .reduce((sum, item) => sum + (item.price || 0), 0);
          total += lunchTotal * people;
        }
      }

      return total.toFixed(2);
    } catch (error) {
      console.error("Error calculating total:", error);
      return "0.00";
    }
  };

  // ========================================
  // MEAL ITEM HANDLERS
  // ========================================
  const handleBreakfastItemChange = (itemName) => {
    setSelectedBreakfastItems((prev) =>
      prev.includes(itemName)
        ? prev.filter((i) => i !== itemName)
        : [...prev, itemName]
    );
  };

  const handleLunchItemChange = (itemName) => {
    setSelectedLunchItems((prev) =>
      prev.includes(itemName)
        ? prev.filter((i) => i !== itemName)
        : [...prev, itemName]
    );
  };

  // ========================================
  // useEffect HOOKS
  // ========================================

  // 🆕 Fetch packages on component mount
  useEffect(() => {
    fetchPackages();
  }, [fetchPackages]);

  // 🆕 Reset to page 1 when filters change
  useEffect(() => {
    setCurrentPage(1);
  }, [searchQuery, filterPark, filterType, sortBy]);

  // 🆕 Update meal selections when vegOption changes - only keep items that match the new filter
  useEffect(() => {
    if (breakfastMenuItems.length > 0) {
      setSelectedBreakfastItems((prev) => {
        // Keep only selected items that match the current vegOption filter
        const filteredBreakfast = breakfastMenuItems.filter((item) => {
          if (vegOption === "veg") {
            return item.isVegetarian !== false;
          }
          return true;
        });
        // Only keep previously selected items that are still in the filtered list
        return prev.filter((selectedName) =>
          filteredBreakfast.some((item) => item.name === selectedName)
        );
      });
    }
    if (lunchMenuItems.length > 0) {
      setSelectedLunchItems((prev) => {
        // Keep only selected items that match the current vegOption filter
        const filteredLunch = lunchMenuItems.filter((item) => {
          if (vegOption === "veg") {
            return item.isVegetarian !== false;
          }
          return true;
        });
        // Only keep previously selected items that are still in the filtered list
        return prev.filter((selectedName) =>
          filteredLunch.some((item) => item.name === selectedName)
        );
      });
    }
  }, [vegOption, breakfastMenuItems, lunchMenuItems]);

  // 🆕 Fetch private availability dates when needed
  useEffect(() => {
    if (reservationType === "private" && selectedPackage) {
      const fetchPrivateAvailability = async () => {
        try {
          const response = await publicFetch(
            `${apiEndpoints.packages.base}/${selectedPackage._id}/availability`
          );
          const data = await response.json();
          
          if (data.success && data.availableDates) {
            setPrivateAvailableDates(data.availableDates);
          }
        } catch (error) {
          console.error("Error fetching availability:", error);
        }
      };

      fetchPrivateAvailability();
    }
  }, [reservationType, selectedPackage, park]);

  // 🆕 Handle preSelectedPackage from navigation
  useEffect(() => {
    if (preSelectedPackage && availablePackages.length > 0) {
      const foundPackage = availablePackages.find(
        (pkg) => pkg._id === preSelectedPackage._id
      );
      if (foundPackage) {
        handlePackageSelect(foundPackage);
      }
    }
  }, [preSelectedPackage, availablePackages, handlePackageSelect]);


  // ========================================
  // VALIDATION & BOOKING
  // ========================================

  const validateBooking = () => {
    if (!selectedPackage) return "Please select a package first";
    if (!pricing) return "Package pricing not loaded. Please refresh the page.";
    if (!fullName.trim()) return "Full Name is required";
    if (!phoneNumber.trim()) return "Phone Number is required";
    if (!email.trim()) return "Email is required";
    
    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) return "Please enter a valid email address";
    
    if (visitorType === "foreign" && !passportNumber.trim())
      return "Passport Number is required";
    if (visitorType === "local" && !nicNumber.trim())
      return "NIC Number is required";
    if (reservationType === "private" && !privateDate)
      return "Please select a date";
    if (reservationType === "shared" && !sharedSelectedDate)
      return "Please select a date";
    if (reservationType === "shared" && !sharedSelectedSeat)
      return "Please select a seat";
    
    return null;
  };

  const handleBookNow = () => {
    const error = validateBooking();
    if (error) {
      toast.error(error);
      return;
    }

    // Calculate meal price
    const calculateMealPrice = () => {
      let meal = 0;
      if (mealOption === "with") {
        if (includeBreakfast && selectedBreakfastItems && selectedBreakfastItems.length > 0) {
          const breakfastTotal = getBreakfastMenu()
            .filter((item) => selectedBreakfastItems.includes(item.name))
            .reduce((sum, item) => sum + (item.price || 0), 0);
          meal += breakfastTotal * people;

          // Add eggs if veg option and includeEggs is true
          if (vegOption === "veg" && includeEggs) {
            meal += 1.5 * people;
          }
        }

        if (includeLunch && selectedLunchItems && selectedLunchItems.length > 0) {
          const lunchTotal = getLunchMenu()
            .filter((item) => selectedLunchItems.includes(item.name))
            .reduce((sum, item) => sum + (item.price || 0), 0);
          meal += lunchTotal * people;
        }
      }
      return Number(meal.toFixed(2));
    };

    // Calculate all prices
    const ticketPricePerPerson = getTicketPrice();
    const calculatedTicketPrice = ticketPricePerPerson * people;

    let calculatedJeepPrice = 0;
    if (reservationType === "private") {
      calculatedJeepPrice = pricing.jeep[jeepType]?.[timeSlot] || 0;
    } else {
      calculatedJeepPrice = (pricing.shared[Math.min(people, 7)] || 0) * people;
    }

    const calculatedGuidePrice =
      reservationType === "private" ? pricing.guide[guideOption] || 0 : 0;
    const calculatedMealPrice = calculateMealPrice();
    const calculatedTotalPrice =
      calculatedTicketPrice +
      calculatedJeepPrice +
      calculatedGuidePrice +
      calculatedMealPrice;

    console.log("📊 Frontend Calculation Summary:");
    console.log("   Package:", selectedPackage.name);
    console.log("   Ticket Price:", calculatedTicketPrice);
    console.log("   Jeep Price:", calculatedJeepPrice);
    console.log("   Guide Price:", calculatedGuidePrice);
    console.log("   Meal Price:", calculatedMealPrice);
    console.log("   TOTAL:", calculatedTotalPrice);

    // Prepare booking data
    const bookingData = {
      // Package information
      packageId: selectedPackage._id,
      packageName: selectedPackage.name,

      // Customer information
      customerName: fullName,
      customerEmail: email,
      customerPhone: phoneNumber,

      // Booking details
      reservationType,
      park,
      block,
      jeepType,
      timeSlot,
      guideOption,
      visitorType,
      mealOption,
      vegOption,
      people,

      // Date and seat selection
      date: reservationType === "private" ? privateDate : sharedSelectedDate,
      selectedSeats: reservationType === "shared" ? sharedSelectedSeat : people,

      // Meal selections
      includeBreakfast,
      includeLunch,
      includeEggs,
      selectedBreakfastItems: includeBreakfast ? selectedBreakfastItems : [],
      selectedLunchItems: includeLunch ? selectedLunchItems : [],

      // Additional information
      pickupLocation,
      hotelWhatsapp,
      accommodation,
      passportNumber: visitorType === "foreign" ? passportNumber : "",
      nicNumber: visitorType === "local" ? nicNumber : "",
      localContact: visitorType === "local" ? localContact : "",
      localAccommodation: visitorType === "local" ? localAccommodation : "",

      // Price breakdown
      ticketPrice: calculatedTicketPrice,
      jeepPrice: calculatedJeepPrice,
      guidePrice: calculatedGuidePrice,
      mealPrice: calculatedMealPrice,
      totalPrice: calculatedTotalPrice,
    };

    console.log("📤 Sending booking data to backend:", bookingData);
    navigate("/booking/confirm", { state: bookingData });
  };

  // ========================================
  // LOADING STATE
  // ========================================

  if (loading || packagesLoading) {
    return (
      <div className="min-h-screen bg-green-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-green-600 mx-auto mb-4"></div>
          <p className="text-xl text-gray-600">Loading packages...</p>
        </div>
      </div>
    );
  }

  // ========================================
  // RETURN JSX
  // ========================================

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#1a1f28] via-[#1b2431] to-[#0f1319] py-12 text-white">
      <div className="max-w-5xl mt-10 mx-auto px-4 lg:px-6">
        {/* Header with Hero Image Carousel */}
        <div className="ui-mdc-package-hero-carousel relative mb-10 h-72 overflow-hidden rounded-3xl border border-white/10 bg-white/5 shadow-2xl shadow-black/30">
          <div className="ui-mdc-package-carousel-container">
            {carouselImages.map((image, index) => (
              <img
                key={index}
                src={image}
                alt={`Safari scene ${index + 1}`}
                className={`ui-mdc-package-carousel-image ${
                  index === currentImageIndex ? 'ui-mdc-package-carousel-image--active' : ''
                }`}
              />
            ))}
          </div>
          <div className="absolute inset-0 flex items-center justify-center bg-gradient-to-b from-black/10 via-black/20 to-black/30">
            <div className="px-6 text-center z-10">
              <span className="inline-flex items-center rounded-full bg-white/10 px-4 py-1 text-xs font-semibold uppercase tracking-[0.35em] text-amber-200/80">
                Tailored safari itineraries
              </span>
              <h1 className="mt-4 text-4xl font-semibold tracking-tight sm:text-5xl">
                {selectedPackage ? selectedPackage.name : "Wildlife Safari Adventure"}
              </h1>
              <p className="mt-3 text-base text-gray-300 sm:text-lg">
                {selectedPackage 
                  ? selectedPackage.description 
                  : "Book your unforgettable jungle experience"}
              </p>
            </div>
          </div>
          {/* Carousel Indicators */}
          <div className="ui-mdc-package-carousel-indicators">
            {carouselImages.map((_, index) => (
              <button
                key={index}
                type="button"
                onClick={() => setCurrentImageIndex(index)}
                className={`ui-mdc-package-carousel-indicator ${
                  index === currentImageIndex ? 'ui-mdc-package-carousel-indicator--active' : ''
                }`}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        </div>

        {/* 🆕 PACKAGE SELECTION SECTION */}
        {showPackageSelector && (
          <div className="mb-10 rounded-3xl border border-white/10 bg-white/5 p-8 shadow-2xl shadow-black/30 backdrop-blur">
            <div className="mb-6 flex flex-col items-start gap-4 md:flex-row md:items-center md:justify-between">
              <div>
                <h2 className="text-2xl font-semibold tracking-tight text-white md:text-3xl">
                  Choose Your Package
                </h2>
                <p className="text-sm text-gray-200">
                  {filteredPackages.length} package{filteredPackages.length !== 1 ? "s" : ""} available
                </p>
              </div> 
            </div>

            {/* Search and Filters */}
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
              {/* Search Bar */}
              <div className="md:col-span-2">
                <div className="relative">
                  <input
                    type="text"
                    placeholder="Search packages..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className="w-full rounded-lg border border-white/10 bg-white/10 pl-10 pr-4 py-2 text-sm text-white placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-[#c4915f]"
                  />
                  <svg
                    className="absolute left-3 top-2.5 h-5 w-5 text-gray-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                    />
                  </svg>
                </div>
              </div>

              {/* Park Filter */}
              <div>
                <select
                  value={filterPark}
                  onChange={(e) => setFilterPark(e.target.value)}
                  className="w-full rounded-lg border border-white/10 bg-white/10 px-4 py-2 text-sm text-white focus:outline-none focus:ring-2 focus:ring-[#c4915f]"
                >
                  <option value="all">All</option>
              
                </select>
              </div>

              {/* Sort By */}
              <div>
                <select
                  value={sortBy}
                  onChange={(e) => setSortBy(e.target.value)}
                  className="w-full rounded-lg border border-white/10 bg-white/10 px-4 py-2 text-sm text-white focus:outline-none focus:ring-2 focus:ring-[#c4915f]"
                >
                  <option value="name">Sort by Name</option>
                  <option value="price-low">Price: Low to High</option>
                  <option value="price-high">Price: High to Low</option>
                </select>
              </div>
            </div>

            {/* Type Filter Tabs */}
            <div className="mb-6 flex gap-2">
              {["all", ].map((type) => (
                <button
                  key={type}
                  onClick={() => setFilterType(type)}
                  className={`rounded-lg px-4 py-2 font-medium capitalize transition-colors ${
                    filterType === type
                      ? "bg-[#c4915f] text-white shadow-lg shadow-[#c4915f]/30"
                      : "bg-white/10 text-gray-200 hover:bg-white/20"
                  }`}
                >
                  {type === "all" ? "All Types" : type}
                </button>
              ))}
            </div>

            {/* Package Grid */}
            {packagesLoading ? (
              <div className="flex justify-center py-12">
                <div className="h-12 w-12 animate-spin rounded-full border-b-2 border-[#c4915f]"></div>
              </div>
            ) : filteredPackages.length === 0 ? (
              <div className="text-center py-12">
                <svg
                  className="mx-auto mb-4 h-16 w-16 text-gray-500"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                <p className="mb-4 text-lg text-gray-600">
                  {searchQuery || filterPark !== "all" || filterType !== "all"
                    ? "No packages match your filters"
                    : "No packages available at the moment"}
                </p>
                {(searchQuery || filterPark !== "all" || filterType !== "all") && (
                  <button
                    onClick={() => {
                      setSearchQuery("");
                      setFilterPark("all");
                      setFilterType("all");
                    }}
                    className="rounded-lg bg-[#c4915f] px-6 py-2 font-semibold text-white shadow-lg shadow-[#c4915f]/30 transition-transform duration-200 hover:-translate-y-0.5 hover:bg-[#b37f4a]"
                  >
                    Clear Filters
                  </button>
                )}
              </div>
            ) : (
              <>
                <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
                  {currentPackages.map((pkg) => (
                    <div
                      key={pkg._id}
                      className="group cursor-pointer overflow-hidden rounded-2xl border border-white/10 bg-white/10 transition-transform duration-300 hover:-translate-y-2 hover:border-white/20 hover:bg-white/15 hover:shadow-2xl hover:shadow-black/30"
                      onClick={() => handlePackageSelect(pkg)}
                    >
                      {/* Package Image */}
                      <div className="relative h-44 overflow-hidden">
                        <img
                        
                          src={pkg.featuredImage || luxuryImage} 
                          alt={pkg.name}
                          className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-110"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/30 to-transparent" />
                        
                        {/* Package Type Badge */}
                        <div className="absolute top-2 right-2">
                          <span className="rounded-full bg-[#c4915f] px-3 py-1 text-xs font-semibold uppercase tracking-wide text-white shadow-lg shadow-[#c4915f]/40">
                            {pkg.packageType === "both"
                              ? "Private & Shared"
                              : pkg.packageType}
                          </span>
                        </div>

                        {/* Highlights Badge */}
                        {pkg.highlights && pkg.highlights.length > 0 && (
                          <div className="absolute bottom-2 left-2">
                            <span className="bg-yellow-500 text-white px-2 py-1 rounded text-xs font-semibold">
                              🌟 {pkg.highlights[0]}
                            </span>
                          </div>
                        )}
                      </div>

                      {/* Package Content */}
                      <div className="p-4">
                        <h3 className="mb-2 line-clamp-1 text-lg font-semibold text-white">
                          {pkg.name}
                        </h3>
                        <p className="mb-3 line-clamp-2 text-sm text-gray-200">
                          {pkg.description}
                        </p>

                        {/* Park Location */}
                        <div className="mb-3 flex items-center text-xs text-gray-400">
                          <svg
                            className="w-4 h-4 mr-1"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                            />
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                            />
                          </svg>
                          <span className="capitalize">{pkg.park} National Park</span>
                        </div>

                    

                        {/* Max Capacity - FROM API */}
                        {pkg.maxCapacity && (
                          <div className="mb-3 flex items-center text-xs text-gray-200">
                            <svg
                              className="w-4 h-4 mr-1"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                              />
                            </svg>
                            Max {pkg.maxCapacity} people
                          </div>
                        )}

                        {/* Features Preview - FROM API */}
                        {pkg.features && pkg.features.length > 0 && (
                          <div className="mb-4">
                            <div className="flex flex-wrap gap-1">
                              {pkg.features.slice(0, 3).map((feature, idx) => (
                                <span
                                  key={idx}
                                  className="rounded border border-white/10 bg-white/10 px-2 py-1 text-xs text-gray-100"
                                >
                                  ✓ {feature}
                                </span>
                              ))}
                              {pkg.features.length > 3 && (
                                <span className="px-2 py-1 text-xs text-gray-400">
                                  +{pkg.features.length - 3} more
                                </span>
                              )}
                            </div>
                          </div>
                        )}

                        {/* Ticket Prices - FROM API */}
                        {pkg.tickets && (
                          <div className="mb-4 text-xs text-gray-200">
                            <div className="flex justify-between">
                              <span>Foreign Ticket:</span>
                              <span className="font-semibold text-white">${pkg.tickets.foreign}</span>
                            </div>
                            <div className="flex justify-between">
                              <span>Local Ticket:</span>
                              <span className="font-semibold text-white">${pkg.tickets.local}</span>
                            </div>
                          </div>
                        )}

                        {/* Select Button */}
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            handlePackageSelect(pkg);
                          }}
                          className="flex w-full items-center justify-center gap-2 rounded-lg bg-[#c4915f] py-2.5 font-semibold text-white shadow-lg shadow-[#c4915f]/30 transition-transform duration-200 hover:-translate-y-0.5 hover:bg-[#b37f4a]"
                        >
                          <svg
                            className="w-5 h-5"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M5 13l4 4L19 7"
                            />
                          </svg>
                          Select This Package
                        </button>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Enhanced Pagination */}
                {totalPages > 1 && (
                  <div className="flex flex-col md:flex-row justify-between items-center gap-4 mt-8">
                    <div className="text-sm text-gray-600">
                      Showing {indexOfFirstPackage + 1} to{" "}
                      {Math.min(indexOfLastPackage, filteredPackages.length)} of{" "}
                      {filteredPackages.length} packages
                    </div>

                    <div className="flex items-center gap-2">
                      <button
                        onClick={() => paginate(currentPage - 1)}
                        disabled={currentPage === 1}
                        className={`p-2 rounded-lg ${
                          currentPage === 1
                            ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                            : "bg-white text-green-600 hover:bg-green-50 border border-green-600"
                        }`}
                      >
                        <svg
                          className="w-5 h-5"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M15 19l-7-7 7-7"
                          />
                        </svg>
                      </button>

                      {[...Array(totalPages)].map((_, index) => {
                        const pageNumber = index + 1;
                        // Show first page, last page, current page, and pages around current
                        if (
                          pageNumber === 1 ||
                          pageNumber === totalPages ||
                          (pageNumber >= currentPage - 1 &&
                            pageNumber <= currentPage + 1)
                        ) {
                          return (
                            <button
                              key={pageNumber}
                              onClick={() => paginate(pageNumber)}
                              className={`px-4 py-2 rounded-lg font-medium ${
                                currentPage === pageNumber
                                  ? "bg-green-600 text-white"
                                  : "bg-white text-green-600 hover:bg-green-50 border border-green-600"
                              }`}
                            >
                              {pageNumber}
                            </button>
                          );
                        } else if (
                          pageNumber === currentPage - 2 ||
                          pageNumber === currentPage + 2
                        ) {
                          return (
                            <span key={pageNumber} className="px-2 text-gray-400">
                              ...
                            </span>
                          );
                        }
                        return null;
                      })}

                      <button
                        onClick={() => paginate(currentPage + 1)}
                        disabled={currentPage === totalPages}
                        className={`p-2 rounded-lg ${
                          currentPage === totalPages
                            ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                            : "bg-white text-green-600 hover:bg-green-50 border border-green-600"
                        }`}
                      >
                        <svg
                          className="w-5 h-5"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M9 5l7 7-7 7"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        )}

        {/* Selected Package Banner */}
        {selectedPackage && !showPackageSelector && (
          <div className="mb-8 flex items-center justify-between gap-4 rounded-2xl border border-white/10 bg-white/5 p-4 shadow-xl shadow-black/30 backdrop-blur">
            <div className="flex items-center gap-4">
              <div className="rounded-full bg-[#c4915f] p-3 text-white shadow-lg shadow-[#c4915f]/40">
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M5 13l4 4L19 7"
                  ></path>
                </svg>
              </div>
              <div>
                <h3 className="text-lg font-semibold text-white">
                  {selectedPackage.name}
                </h3>
                <p className="text-sm text-gray-200">
                  You can customize the details below
                </p>
              </div>
            </div>
            <button
              onClick={() => {
                setSelectedPackage(null);
                setPricing(null);
                setShowPackageSelector(true);
              }}
              className="rounded-lg border border-white/20 px-4 py-2 text-sm font-medium text-white transition-colors duration-200 hover:bg-white/10"
            >
              Change Package
            </button>
          </div>
        )}

        {/* Main Booking Card - Only show if package is selected */}
        {!showPackageSelector && selectedPackage && pricing && (
          <div className="overflow-hidden rounded-3xl border border-white/10 bg-white/95 text-slate-900 shadow-2xl shadow-black/40 backdrop-blur">
            {/* Progress Steps */}
            <div className="flex divide-x divide-gray-200 border-b border-gray-200">
              {["Reservation", "Park", "Jeep", "Guide", "Meals", "Summary"].map(
                (step, index) => (
                  <div
                    key={step}
                    className="flex-1 py-4 text-center font-medium text-green-700"
                  >
                    {step}
                  </div>
                )
              )}
            </div>

            <div className="p-8 md:p-10 text-[#1a1f28]">
              {/* 1. RESERVATION TYPE */}
              <section className="mb-10">
                <h2 className="mb-6 flex items-center text-2xl font-semibold tracking-tight">
                  <span className="mr-3 flex h-9 w-9 items-center justify-center rounded-full bg-[#c4915f] text-sm font-bold text-[#1a1f28] shadow-lg shadow-[#c4915f]/40">
                    1
                  </span>
                  Choose Your Safari Type
                </h2>

                <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
                  {/* Private Safari - Show only if package supports it */}
                  {(selectedPackage.packageType === "private" ||
                    selectedPackage.packageType === "both") && (
                    <div
                      onClick={() => setReservationType("private")}
                      className={`cursor-pointer rounded-2xl border border-white/10 bg-white/5 p-6 transition-all duration-300 hover:-translate-y-1 hover:border-white/20 hover:bg-white/10 ${
                        reservationType === "private"
                          ? "ring-1 ring-[#c4915f]/60 shadow-xl shadow-black/30"
                          : ""
                      }`}
                    >
                      <div className="flex items-start gap-3">
                        <div
                          className={`mt-1 h-5 w-5 flex-shrink-0 rounded-full border ${
                            reservationType === "private"
                              ? "border-transparent bg-[#c4915f]"
                              : "border-white/40 bg-transparent"
                          }`}
                        />
                        <div>
                          <h3 className="mb-2 text-xl font-semibold text-[#1a1f28]">
                            Private Safari
                          </h3>
                          <p className="mb-3 text-sm text-gray-600">
                            Exclusive jeep for your group. Available at all parks.
                          </p>
                          <ul className="space-y-1 text-sm text-gray-600">
                            <li className="flex items-center gap-2">
                              <svg
                                className="h-4 w-4 text-[#1a1f28]"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M5 13l4 4L19 7"
                                ></path>
                              </svg>
                              Flexible timing
                            </li>
                            <li className="flex items-center gap-2">
                              <svg
                                className="h-4 w-4 text-[#1a1f28]"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M5 13l4 4L19 7"
                                ></path>
                              </svg>
                              Personalized experience
                            </li>
                          </ul>
                        </div>
                      </div>

                      {/* Calendar for private safari */}
                      {reservationType === "private" && (
                        <div className="mt-6">
                          <label className="mb-2 block text-sm font-semibold uppercase tracking-wide text-gray-700">
                            Select Date
                          </label>
                          <Calendar
                            value={privateDate}
                            onChange={setPrivateDate}
                            minDate={new Date()}
                            maxDate={
                              new Date(Date.now() + 90 * 24 * 60 * 60 * 1000)
                            }
                            tileDisabled={({ date, view }) =>
                              view === "month" &&
                              privateAvailableDates.length > 0 &&
                              !privateAvailableDates.includes(
                                date.toISOString().slice(0, 10)
                              )
                            }
                            tileClassName={({ date, view }) =>
                              view === "month" &&
                              privateDate &&
                              date.toDateString() ===
                                new Date(privateDate).toDateString()
                                ? "react-calendar__tile--active rounded-full bg-[#c4915f] text-white font-semibold shadow-lg shadow-[#c4915f]/40"
                                : "rounded-full text-slate-700"
                            }
                          />
                          <div className="mt-2 text-sm text-gray-600">
                            Selected:{" "}
                            {privateDate
                              ? moment(privateDate).format("MMMM D, YYYY")
                              : "None"}
                          </div>
                        </div>
                      )}
                    </div>
                  )}

                  {/* Shared Safari - Show only if package supports it */}
                  {(selectedPackage.packageType === "shared" ||
                    selectedPackage.packageType === "both") && (
                    <div
                      onClick={() => setReservationType("shared")}
                      className={`cursor-pointer rounded-2xl border border-white/10 bg-white/5 p-6 transition-all duration-300 hover:-translate-y-1 hover:border-white/20 hover:bg-white/10 ${
                        reservationType === "shared"
                          ? "ring-1 ring-[#c4915f]/60 shadow-xl shadow-black/30"
                          : ""
                      }`}
                    >
                      <div className="flex items-start gap-3">
                        <div
                          className={`mt-1 h-5 w-5 flex-shrink-0 rounded-full border ${
                            reservationType === "shared"
                              ? "border-transparent bg-[#c4915f]"
                              : "border-white/40 bg-transparent"
                          }`}
                        />
                        <div>
                          <h3 className="mb-2 text-xl font-semibold text-white">
                            Shared Safari
                          </h3>
                          <p className="mb-3 text-sm text-gray-600">
                            Join other guests for a cost-effective safari experience.
                          </p>
                          <ul className="space-y-1 text-sm text-gray-600">
                            <li className="flex items-center gap-2">
                              <svg
                                className="h-4 w-4 text-[#c4915f]"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M5 13l4 4L19 7"
                                ></path>
                              </svg>
                              Fixed departure times
                            </li>
                            <li className="flex items-center gap-2">
                              <svg
                                className="h-4 w-4 text-[#c4915f]"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M5 13l4 4L19 7"
                                ></path>
                              </svg>
                              Share the adventure with others
                            </li>
                          </ul>
                        </div>
                      </div>

                      {reservationType === "shared" && (
                        <div className="mt-6">
                          <button
                            className="rounded-lg bg-[#c4915f] px-4 py-2 text-sm font-semibold text-white shadow-lg shadow-[#c4915f]/30 transition-transform duration-200 hover:-translate-y-0.5 hover:bg-[#b37f4a]"
                            onClick={(e) => {
                              e.stopPropagation();
                              setShowDatePopup(true);
                            }}
                          >
                            Select Date
                          </button>
                        </div>
                      )}
                    </div>
                  )}
                </div>

                {/* Date Selection Modal for Shared Safari */}
                <Modal
                  isOpen={showDatePopup}
                  onRequestClose={() => setShowDatePopup(false)}
                  className="mx-auto mt-32 max-w-md rounded-2xl border border-white/10 bg-slate-900/90 p-8 text-white shadow-2xl shadow-black/40 backdrop-blur"
                  overlayClassName="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm"
                >
                  <h2 className="mb-4 text-xl font-semibold">
                    Select Your Safari Date
                  </h2>
                  <Calendar
                    value={sharedSelectedDate}
                    onChange={setSharedSelectedDate}
                    minDate={new Date()}
                    tileClassName={({ date, view }) =>
                      view === "month" &&
                      sharedSelectedDate &&
                      date.toDateString() === sharedSelectedDate.toDateString()
                        ? "react-calendar__tile--active rounded-full bg-[#c4915f] text-white font-semibold shadow-lg shadow-[#c4915f]/40"
                        : "rounded-full text-slate-700"
                    }
                    className="mb-6 rounded-xl border border-white/10 bg-white"
                  />
                  <div className="mt-6 flex justify-end gap-3">
                    <button
                      className="rounded-lg border border-white/20 px-4 py-2 text-sm font-medium text-gray-700 transition-colors duration-200 hover:bg-white/10"
                      onClick={() => setShowDatePopup(false)}
                    >
                      Cancel
                    </button>
                    <button
                      className="rounded-lg bg-[#c4915f] px-4 py-2 text-sm font-semibold text-white shadow-lg shadow-[#c4915f]/30 transition-transform duration-200 hover:-translate-y-0.5 hover:bg-[#b37f4a]"
                      disabled={!sharedSelectedDate}
                      onClick={() => {
                        setShowDatePopup(false);
                        toast.success("Date selected!");
                      }}
                    >
                      OK
                    </button>
                  </div>
                </Modal>

                {/* Seat Selection Modal */}
                <Modal
                  isOpen={showSeatPopup}
                  onRequestClose={() => setShowSeatPopup(false)}
                  className="mx-auto mt-32 max-w-md rounded-2xl border border-white/10 bg-slate-900/90 p-8 text-white shadow-2xl shadow-black/40 backdrop-blur"
                  overlayClassName="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm"
                >
                  <h2 className="mb-4 text-xl font-semibold">Select Your Seat</h2>
                  <div className="mb-6 flex flex-wrap gap-3">
                    {[1, 2, 3, 4, 5, 6, 7].map((seat) => (
                      <button
                        key={seat}
                        disabled={sharedBookedSeats.includes(seat)}
                        onClick={() => setSharedSelectedSeat(seat)}
                        className={`flex h-12 w-12 items-center justify-center rounded-full border-2 text-lg font-semibold transition-colors duration-200
                          ${
                            sharedBookedSeats.includes(seat)
                              ? "cursor-not-allowed border-white/10 bg-white/10 text-gray-400"
                              : sharedSelectedSeat === seat
                              ? "border-transparent bg-[#c4915f] text-white shadow-lg shadow-[#c4915f]/30"
                              : "border-white/20 bg-white/5 text-gray-100 hover:bg-white/10"
                          }
                        `}
                      >
                        {seat}
                      </button>
                    ))}
                  </div>
                  <div className="flex justify-end gap-3">
                    <button
                      className="rounded-lg border border-white/20 px-4 py-2 text-sm font-medium text-gray-700 transition-colors duration-200 hover:bg-white/10"
                      onClick={() => setShowSeatPopup(false)}
                    >
                      Cancel
                    </button>
                    <button
                      className="rounded-lg bg-[#c4915f] px-4 py-2 text-sm font-semibold text-white shadow-lg shadow-[#c4915f]/30 transition-transform duration-200 hover:-translate-y-0.5 hover:bg-[#b37f4a]"
                      disabled={!sharedSelectedSeat}
                      onClick={() => {
                        setShowSeatPopup(false);
                        toast.success(`Seat ${sharedSelectedSeat} selected!`);
                      }}
                    >
                      OK
                    </button>
                  </div>
                </Modal>

                {/* Contact Modal for Shared Safari */}
                <Modal
                  isOpen={reservationType === "shared" && showBookingSection}
                  onRequestClose={() => setShowBookingSection(false)}
                  className="mx-auto mt-32 max-w-md rounded-2xl border border-white/10 bg-slate-900/90 p-8 text-white shadow-2xl shadow-black/40 backdrop-blur"
                  overlayClassName="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm"
                >
                  <h2 className="mb-4 text-xl font-semibold">Contact Details</h2>
                  <p className="mb-6 text-sm text-gray-700">
                    Are you Interested in this Shared Safari? 📅 Check the
                    available dates and safari details. 📞 To join this safari,
                    please contact us directly at +94 773 742 700
                  </p>
                  <button
                    type="button"
                    className="mb-4 inline-flex items-center gap-2 rounded-lg bg-[#25D366] px-4 py-2 text-sm font-semibold text-white shadow-lg shadow-[#25D366]/30 transition-transform duration-200 hover:-translate-y-0.5"
                    onClick={() => {
                      window.open(
                        `https://wa.me/+94773742700?text=Hello! I am interested in booking a shared safari. My name is ${
                          fullName || ""
                        }.`,
                        "_blank"
                      );
                    }}
                  >
                    <svg
                      className="h-5 w-5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M16 12v1a4 4 0 01-8 0v-1m8 0a4 4 0 00-8 0m8 0V8a4 4 0 00-8 0v4"
                      />
                    </svg>
                    Contact via WhatsApp
                  </button>
                  <button
                    onClick={() => setShowBookingSection(false)}
                    className="w-full rounded-lg border border-white/20 px-4 py-2 text-sm font-medium text-gray-700 transition-colors duration-200 hover:bg-white/10"
                  >
                    Close
                  </button>
                </Modal>
              </section>

              {/* 2. PARK SELECTION - Display from API */}
              <section className="mb-10">
                <h2 className="mb-6 flex items-center text-2xl font-semibold tracking-tight text-[#1a1f28]">
                  <span className="mr-3 flex h-9 w-9 items-center justify-center rounded-full bg-[#c4915f] text-sm font-bold text-[#1a1f28] shadow-lg shadow-[#c4915f]/40">
                    2
                  </span>
                  Safari Park
                </h2>

                <div className="rounded-2xl border border-white/10 bg-white/5 p-6 text-[#1a1f28] shadow-inner shadow-black/20">
                  <div className="flex items-center gap-4">
                    <img
                      src={parkImages[selectedPackage.park] || yalaImage}
                      alt={selectedPackage.park}
                      className="h-24 w-24 rounded-lg object-cover shadow-lg shadow-black/40"
                    />
                    <div>
                      <h3 className="text-xl font-semibold capitalize text-[#1a1f28]">
                        {selectedPackage.park} National Park
                      </h3>
                      <p className="mt-1 text-sm text-gray-600">
                        Selected from your package
                      </p>
                      {selectedPackage.block && (
                        <p className="mt-2 text-sm font-medium text-[#c4915f]">
                          Block: {selectedPackage.block}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </section>

              {/* 3. JEEP OPTIONS - FROM API */}
              <section className="mb-10">
                <h2 className="mb-6 flex items-center text-2xl font-semibold tracking-tight text-[#1a1f28]">
                  <span className="mr-3 flex h-9 w-9 items-center justify-center rounded-full bg-[#c4915f] text-sm font-bold text-[#1a1f28] shadow-lg shadow-[#c4915f]/40">
                    3
                  </span>
                  Choose Your Safari Vehicle
                </h2>

                <div className="mb-8 grid grid-cols-1 gap-6 md:grid-cols-3">
                  {/* Basic Jeep - FROM API */}
                  {pricing.jeep.basic && pricing.jeep.basic.morning !== 0 && (
                    <div
                      onClick={() => setJeepType("basic")}
                      className={`cursor-pointer rounded-2xl border border-white/10 bg-white/5 p-5 transition-all duration-300 hover:-translate-y-1 hover:border-white/20 hover:bg-white/10 ${
                        jeepType === "basic"
                          ? "ring-1 ring-[#c4915f]/60 shadow-xl shadow-black/30"
                          : ""
                      }`}
                    >
                      <div className="mb-3 flex items-start justify-between">
                        <h3 className="text-xl font-semibold text-[#1a1f28]">Basic Jeep</h3>
                        <span className="rounded bg-white/10 px-2 py-1 text-sm font-semibold text-[#c4915f]">
                          ${pricing.jeep.basic.morning}-${pricing.jeep.basic.fullDay}
                        </span>
                      </div>
                      <img
                        src={basicImage}
                        alt="Basic Jeep"
                        className="mb-3 h-32 w-full rounded-lg object-cover shadow-lg shadow-black/30"
                      />
                      <ul className="space-y-1 text-sm text-gray-600">
                        <li className="flex items-start gap-2">
                          <svg
                            className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#1a1f28]"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M5 13l4 4L19 7"
                            ></path>
                          </svg>
                          Adjustable Seats
                        </li>
                        <li className="flex items-start gap-2">
                          <svg
                            className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#1a1f28]"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M5 13l4 4L19 7"
                            ></path>
                          </svg>
                          360° Viewing
                        </li>
                        <li className="flex items-start gap-2">
                          <svg
                            className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#1a1f28]"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M5 13l4 4L19 7"
                            ></path>
                          </svg>
                         Binocular viewing
                        </li>
                        <li className="flex items-start gap-2">
                          <svg
                            className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#1a1f28]"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M5 13l4 4L19 7"
                            ></path>
                          </svg>
                          1-7 Seating Capacity
                        </li>                       
                        <li className="flex items-start gap-2">
                          <svg
                            className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#1a1f28]"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M5 13l4 4L19 7"
                            ></path>
                          </svg>
                          Mahindra Maxi
                        </li>
                      </ul>
                      
                      <button className="w-full rounded-lg bg-[#c4915f] mt-4 px-4 py-2 text-white hover:bg-[#c4915f]/80">
                        Tap to Select 
                      </button>
                    </div>
                  )}

                  {/* Luxury Jeep - FROM API */}
                  {pricing.jeep.luxury && pricing.jeep.luxury.morning !== 0 && (
                    <div
                      onClick={() => setJeepType("luxury")}
                      className={`cursor-pointer rounded-2xl border border-white/10 bg-white/5 p-5 transition-all duration-300 hover:-translate-y-1 hover:border-white/20 hover:bg-white/10 ${
                        jeepType === "luxury"
                          ? "ring-1 ring-[#c4915f]/60 shadow-xl shadow-black/30"
                          : ""
                      }`}
                    >
                      <div className="mb-3 flex items-start justify-between">
                        <h3 className="text-xl font-semibold text-[#1a1f28]">Luxury Jeep</h3>
                        <span className="rounded bg-white/10 px-2 py-1 text-sm font-semibold text-[#c4915f]">
                          ${pricing.jeep.luxury.morning}-${pricing.jeep.luxury.fullDay}
                        </span>
                      </div>
                      <img
                        src={luxuryImage}
                        alt="Luxury Jeep"
                        className="mb-3 h-32 w-full rounded-lg object-cover shadow-lg shadow-black/30"
                      />
                      <ul className="space-y-1 text-sm text-gray-600">
                        <li className="flex items-start gap-2">
                          <svg
                            className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#1a1f28]"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M5 13l4 4L19 7"
                            ></path>
                          </svg>
                          Adjustable Seats
                        </li>
                        <li className="flex items-start gap-2">
                          <svg
                            className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#1a1f28]"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M5 13l4 4L19 7"
                            ></path>
                          </svg>
                          360° Viewing
                        </li>
                        <li className="flex items-start gap-2">
                          <svg
                            className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#1a1f28]"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M5 13l4 4L19 7"
                            ></path>
                          </svg>
                         Binocular viewing
                        </li>
                        <li className="flex items-start gap-2">
                          <svg
                            className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#1a1f28]"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M5 13l4 4L19 7"
                            ></path>
                          </svg>
                          1-7 Seating Capacity
                        </li>
                        <li className="flex items-start gap-2">
                          <svg
                            className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#1a1f28]"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M5 13l4 4L19 7"
                            ></path>
                          </svg>
                          Charging ports
                        </li>
                        <li className="flex items-start gap-2">
                          <svg
                            className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#1a1f28]"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M5 13l4 4L19 7"
                            ></path>
                          </svg>
                          Toyota Hilux
                        </li>
                      </ul>

                      <button className="w-full rounded-lg bg-[#c4915f] mt-4 px-4 py-2 text-white hover:bg-[#c4915f]/80">
                        Tap to Select 
                      </button>
                    </div>
                  )}

                  {/* Super Luxury Jeep - FROM API */}
                  {pricing.jeep.superLuxury && pricing.jeep.superLuxury.morning !== 0 && (
                    <div
                      onClick={() => setJeepType("superLuxury")}
                      className={`cursor-pointer rounded-2xl border border-white/10 bg-white/5 p-5 transition-all duration-300 hover:-translate-y-1 hover:border-white/20 hover:bg-white/10 ${
                        jeepType === "superLuxury"
                          ? "ring-1 ring-[#c4915f]/60 shadow-xl shadow-black/30"
                          : ""
                      }`}
                    >
                      <div className="mb-3 flex items-start justify-between">
                        <h3 className="text-xl font-semibold text-[#1a1f28]">Super Luxury</h3>
                        <span className="rounded bg-white/10 px-2 py-1 text-sm font-semibold text-[#c4915f]">
                          ${pricing.jeep.superLuxury.morning}-$
                          {pricing.jeep.superLuxury.fullDay}
                        </span>
                      </div>
                      <img
                        src={jeepImage}
                        alt="Super Luxury Jeep"
                        className="mb-3 h-32 w-full rounded-lg object-cover shadow-lg shadow-black/30"
                      />
                      <ul className="space-y-1 text-sm text-gray-600">
                        <li className="flex items-start gap-2">
                          <svg
                            className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#1a1f28]"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M5 13l4 4L19 7"
                            ></path>
                          </svg>
                          Adjustable Seats
                        </li>
                        <li className="flex items-start gap-2">
                          <svg
                            className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#1a1f28]"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M5 13l4 4L19 7"
                            ></path>
                          </svg>
                          360° Viewing
                        </li>
                        <li className="flex items-start gap-2">
                          <svg
                            className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#1a1f28]"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M5 13l4 4L19 7"
                            ></path>
                          </svg>
                         Binocular viewing
                        </li>
                        <li className="flex items-start gap-2">
                          <svg
                            className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#1a1f28]"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M5 13l4 4L19 7"
                            ></path>
                          </svg>
                          1-7 Seating Capacity
                        </li>
                        <li className="flex items-start gap-2">
                          <svg
                            className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#1a1f28]"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M5 13l4 4L19 7"
                            ></path>
                          </svg>
                          Charging ports
                        </li>
                        <li className="flex items-start gap-2">
                          <svg
                            className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#1a1f28]"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M5 13l4 4L19 7"
                            ></path>
                          </svg>
                          Refreshments included
                        </li>
                        <li className="flex items-start gap-2">
                          <svg
                            className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#1a1f28]"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M5 13l4 4L19 7"
                            ></path>
                          </svg>
                          Toyota Land Cruiser
                        </li>
                      </ul>
                    </div>
                  )}
                </div>

                {/* Time Slots - Prices FROM API */}
                <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
                  {[
                    {
                      id: "morning",
                      name: "Morning",
                      time: "5:30 AM - 10:30 AM",
                    },
                    {
                      id: "afternoon",
                      name: "Afternoon",
                      time: "1:30 PM - 6:00 PM",
                    },
                    {
                      id: "extended",
                      name: "Extended",
                      time: "5:30 AM - 12:00 PM",
                    },
                    {
                      id: "fullDay",
                      name: "Full Day",
                      time: "5:30 AM - 6:30 PM",
                    },
                  ].map((slot) => (
                    <div
                      key={slot.id}
                      onClick={() => setTimeSlot(slot.id)}
                      className={`cursor-pointer rounded-xl border border-white/10 bg-white/5 p-4 transition-all duration-200 hover:border-white/20 hover:bg-white/10 ${
                        timeSlot === slot.id
                          ? "ring-1 ring-[#c4915f]/60 shadow-lg shadow-black/30"
                          : ""
                      }`}
                    >
                      <div className="text-sm font-semibold text-[#1a1f28]">{slot.name}</div>
                      <div className="text-xs text-gray-600">{slot.time}</div>
                      <div className="mt-1 text-sm font-semibold text-[#c4915f]">
                        {/* PRICE FROM API */}
                        {pricing.jeep[jeepType] && pricing.jeep[jeepType][slot.id]
                          ? `$${pricing.jeep[jeepType][slot.id]}`
                          : "-"}
                      </div>
                    </div>
                  ))}
                </div>
              </section>

              {/* 4. GUIDE OPTIONS - FROM API */}
              <section className="mb-10">
                <h2 className="mb-6 flex items-center text-2xl font-semibold tracking-tight text-[#1a1f28]">
                  <span className="mr-3 flex h-9 w-9 items-center justify-center rounded-full bg-[#c4915f] text-sm font-bold text-white shadow-lg shadow-[#c4915f]/40">
                    4
                  </span>
                  Select Your Guide Option
                </h2>

                <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
                  {/* Driver Only - FROM API */}
                  {pricing.guide.driver !== undefined && (
                    <div
                      onClick={() => setGuideOption("driver")}
                      className={`cursor-pointer rounded-2xl border border-white/10 bg-white/5 p-5 transition-all duration-300 hover:-translate-y-1 hover:border-white/20 hover:bg-white/10 ${
                        guideOption === "driver"
                          ? "ring-1 ring-[#c4915f]/60 shadow-xl shadow-black/30"
                          : ""
                      }`}
                    >
                      <div className="mb-2 flex items-start justify-between">
                        <h3 className="text-lg font-semibold text-[#1a1f28]">Driver Only</h3>
                        <span className="rounded bg-white/10 px-2 py-1 text-xs font-semibold text-[#c4915f]">
                          +${pricing.guide.driver}
                        </span>
                      </div>  
                      <p className="text-sm text-gray-600">
                        Basic transportation with a driver who knows the routes
                      </p>
                    </div>
                  )}

                  {/* Driver Guide - FROM API */}
                  {pricing.guide.driverGuide !== undefined && (
                    <div
                      onClick={() => setGuideOption("driverGuide")}
                      className={`cursor-pointer rounded-2xl border border-white/10 bg-white/5 p-5 transition-all duration-300 hover:-translate-y-1 hover:border-white/20 hover:bg-white/10 ${
                        guideOption === "driverGuide"
                          ? "ring-1 ring-[#c4915f]/60 shadow-xl shadow-black/30"
                          : ""
                      }`}
                    >
                      <div className="mb-2 flex items-start justify-between">
                        <h3 className="text-lg font-semibold text-[#1a1f28]">Driver Guide</h3>
                        <span className="rounded bg-white/10 px-2 py-1 text-xs erinnern font-semibold text-[#c4915f]">
                          +${pricing.guide.driverGuide}
                        </span>
                      </div>
                      <p className="text-sm text-gray-600">
                        Driver who also serves as your wildlife guide
                      </p>
                    </div>
                  )}

                  {/* Separate Guide - FROM API */}
                  {pricing.guide.separateGuide !== undefined && (
                    <div
                      onClick={() => setGuideOption("separateGuide")}
                      className={`cursor-pointer rounded-2xl border border-white/10 bg-white/5 p-5 transition-all duration-300 hover:-translate-y-1 hover:border-white/20 hover:bg-white/10 ${
                        guideOption === "separateGuide"
                          ? "ring-1 ring-[#c4915f]/60 shadow-xl shadow-black/30"
                          : ""
                      }`}
                    >
                      <div className="mb-2 flex items-start justify-between">
                        <h3 className="text-lg font-semibold text-[#1a1f28]">
                          Driver + Guide
                        </h3>
                        <span className="rounded bg-white/10 px-2 py-1 text-xs font-semibold text-[#c4915f]">
                          +${pricing.guide.separateGuide}
                        </span>
                      </div>
                      <p className="text-sm text-gray-600">
                        Dedicated driver and professional wildlife guide
                      </p>
                    </div>
                  )}
                </div>
              </section>

              {/* 5. VISITOR DETAILS & MEAL OPTIONS */}
              <section className="mb-10">
                <h2 className="mb-6 flex items-center text-2xl font-semibold tracking-tight text-[#1a1f28]">
                  <span className="mr-3 flex h-9 w-9 items-center justify-center rounded-full bg-[#c4915f] text-sm font-bold text-[#1a1f28] shadow-lg shadow-[#c4915f]/40">
                    5
                  </span>
                  Visitor Details & Meal Options
                </h2>

                <div className="grid grid-cols-1 gap-8 md:grid-cols-2">
                  {/* VISITOR TYPE & PEOPLE */}
                  <div>
                    <div className="mb-6">
                      <h3 className="mb-3 text-sm font-semibold uppercase tracking-wide text-gray-700">
                        Visitor Type
                      </h3>
                      <div className="flex gap-3">
                        {["foreign", "local"].map((type) => (
                          <button
                            key={type}
                            onClick={() => setVisitorType(type)}
                            className={`rounded-lg px-4 py-2 text-sm font-medium capitalize transition-colors duration-200 ${
                              visitorType === type
                                ? "bg-[#c4915f] text-[#1a1f28] shadow-lg shadow-[#c4915f]/30"
                                : "bg-white/10 text-gray-700 hover:bg-white/20"
                            }`}
                          >
                            {type} Visitor
                          </button>
                        ))}
                      </div>
                      {/* TICKET PRICE FROM API */}
                      <div className="mt-2 text-sm text-gray-600">
                        Ticket Price:{" "}
                        <span className="font-semibold text-[#c4915f]">
                          ${getTicketPrice()}
                        </span>{" "}
                        per person
                      </div>
                    </div>

                    {/* NUMBER OF PEOPLE */}
                    <div>
                      <h3 className="mb-3 text-sm font-semibold uppercase tracking-wide text-gray-700">
                        Number of People
                      </h3>
                      <div className="mt-4 flex items-center gap-4">
                        <button
                          onClick={() => setPeople(Math.max(1, people - 1))}
                          className="flex h-10 w-10 items-center justify-center rounded-full border border-white/10 bg-white/5 text-[#1a1f28] transition-colors duration-200 hover:bg-white/15"
                        >
                          <svg
                            className="h-6 w-6"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M20 12H4"
                            ></path>
                          </svg>
                        </button>
                        <span className="w-10 text-center text-2xl font-semibold text-[#1a1f28]">
                          {people}
                        </span>
                        <button
                          onClick={() =>
                            setPeople(
                              Math.min(selectedPackage.maxCapacity || 7, people + 1)
                            )
                          }
                          className="flex h-10 w-10 items-center justify-center rounded-full border border-white/10 bg-white/5 text-[#1a1f28] transition-colors duration-200 hover:bg-white/15"
                        >
                          <svg
                            className="h-6 w-6"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                            ></path>
                          </svg>
                        </button>
                      </div>
                      <p className="mt-2 text-sm text-gray-400">
                        Max{" "}
                        <span className="font-semibold text-[#c4915f]">
                          {selectedPackage.maxCapacity || 7}
                        </span>{" "}
                        people
                      </p>
                    </div>

                    {/* FOREIGN VISITOR FIELDS */}
                    {visitorType === "foreign" && (
                      <div className="mt-6 space-y-4">
                        <div>
                          <label
                            className="mb-1 block text-sm font-medium text-gray-700"
                            htmlFor="fullName"
                          >
                            Full Name *
                          </label>
                          <input
                            id="fullName"
                            type="text"
                            value={fullName}
                            onChange={(e) => setFullName(e.target.value)}
                            className="w-full rounded-lg border border-white/15 bg-white/5 px-3 py-2 text-sm text-[#1a1f28] placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-[#c4915f]"
                            placeholder="Enter your full name"
                            required
                          />
                        </div>
                        <div>
                          <label
                            className="mb-1 block text-sm font-medium text-gray-700"
                            htmlFor="phoneNumber"
                          >
                            Phone Number *
                          </label>
                          <input
                            id="phoneNumber"
                            type="tel"
                            value={phoneNumber}
                            onChange={(e) => setPhoneNumber(e.target.value)}
                            className="w-full rounded-lg border border-white/15 bg-white/5 px-3 py-2 text-sm text-[#1a1f28] placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-[#c4915f]"
                            placeholder="Enter your phone number"
                            required
                          />
                        </div>
                        <div>
                          <label
                            className="mb-1 block text-sm font-medium text-gray-700"
                            htmlFor="email"
                          >
                            Email Address *
                          </label>
                          <input
                            id="email"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="w-full rounded-lg border border-white/15 bg-white/5 px-3 py-2 text-sm text-[#1a1f28] placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-[#c4915f]"
                            placeholder="Enter your email address"
                            required
                          />
                        </div>
                        <div>
                          <label
                            className="mb-1 block text-sm font-medium text-gray-700"
                            htmlFor="pickupLocation"
                          >
                            Pickup Location
                          </label>
                          <input
                            id="pickupLocation"
                            type="text"
                            value={pickupLocation || ""}
                            onChange={(e) => setPickupLocation(e.target.value)}
                            className="w-full rounded-lg border border-white/15 bg-white/5 px-3 py-2 text-sm text-[#1a1f28] placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-[#c4915f]"
                            placeholder="Enter pickup location"
                          />
                        </div>
                        <div>
                          <label
                            className="mb-1 block text-sm font-medium text-gray-700"
                            htmlFor="hotelWhatsapp"
                          >
                            Hotel WhatsApp Number
                          </label>
                          <input
                            id="hotelWhatsapp"
                            type="text"
                            value={hotelWhatsapp || ""}
                            onChange={(e) => setHotelWhatsapp(e.target.value)}
                            className="w-full rounded-lg border border-white/15 bg-white/5 px-3 py-2 text-sm text-[#1a1f28] placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-[#c4915f]"
                            placeholder="Enter WhatsApp number"
                          />
                        </div>
                        <div>
                          <label
                            className="mb-1 block text-sm font-medium text-gray-700"
                            htmlFor="accommodation"
                          >
                            Accommodation Details
                          </label>
                          <input
                            id="accommodation"
                            type="text"
                            value={accommodation || ""}
                            onChange={(e) => setAccommodation(e.target.value)}
                            className="w-full rounded-lg border border-white/15 bg-white/5 px-3 py-2 text-sm text-[#1a1f28] placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-[#c4915f]"
                            placeholder="Enter accommodation details"
                          />
                        </div>
                        <div>
                          <label
                            className="mb-1 block text-sm font-medium text-gray-700"
                            htmlFor="passportNumber"
                          >
                            Passport Number *
                          </label>
                          <input
                            id="passportNumber"
                            type="text"
                            value={passportNumber || ""}
                            onChange={(e) => setPassportNumber(e.target.value)}
                            className="w-full rounded-lg border border-white/15 bg-white/5 px-3 py-2 text-sm text-[#1a1f28] placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-[#c4915f]"
                            placeholder="Enter passport number"
                            required
                          />
                        </div>
                      </div>
                    )}

                    {/* LOCAL VISITOR FIELDS */}
                    {visitorType === "local" && (
                      <div className="mt-6 space-y-4">
                        <div>
                          <label
                            className="mb-1 block text-sm font-medium text-gray-700"
                            htmlFor="fullName"
                          >
                            Full Name *
                          </label>
                          <input
                            id="fullName"
                            type="text"
                            value={fullName}
                            onChange={(e) => setFullName(e.target.value)}
                            className="w-full rounded-lg border border-white/15 bg-white/5 px-3 py-2 text-sm text-[#1a1f28] placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-[#c4915f]"
                            placeholder="Enter your full name"
                            required
                          />
                        </div>
                        <div>
                          <label
                            className="mb-1 block text-sm font-medium text-gray-700"
                            htmlFor="phoneNumber"
                          >
                            Phone Number *
                          </label>
                          <input
                            id="phoneNumber"
                            type="tel"
                            value={phoneNumber}
                            onChange={(e) => setPhoneNumber(e.target.value)}
                            className="w-full rounded-lg border border-white/15 bg-white/5 px-3 py-2 text-sm text-[#1a1f28] placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-[#c4915f]"
                            placeholder="Enter your phone number"
                            required
                          />
                        </div>
                        <div>
                          <label
                            className="mb-1 block text-sm font-medium text-gray-700"
                            htmlFor="email"
                          >
                            Email Address *
                          </label>
                          <input
                            id="email"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="w-full rounded-lg border border-white/15 bg-white/5 px-3 py-2 text-sm text-[#1a1f28] placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-[#c4915f]"
                            placeholder="Enter your email address"
                            required
                          />
                        </div>
                        <div>
                          <label
                            className="mb-1 block text-sm font-medium text-gray-700"
                            htmlFor="nicNumber"
                          >
                            NIC Number *
                          </label>
                          <input
                            id="nicNumber"
                            type="text"
                            value={nicNumber}
                            onChange={(e) => setNicNumber(e.target.value)}
                            className="w-full rounded-lg border border-white/15 bg-white/5 px-3 py-2 text-sm text-[#1a1f28] placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-[#c4915f]"
                            placeholder="Enter NIC number"
                            required
                          />
                        </div>
                        <div>
                          <label
                            className="mb-1 block text-sm font-medium text-gray-700"
                            htmlFor="localContact"
                          >
                            Contact Number
                          </label>
                          <input
                            id="localContact"
                            type="text"
                            value={localContact}
                            onChange={(e) => setLocalContact(e.target.value)}
                            className="w-full rounded-lg border border-white/15 bg-white/5 px-3 py-2 text-sm text-[#1a1f28] placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-[#c4915f]"
                            placeholder="Enter contact number"
                          />
                        </div>
                        <div>
                          <label
                            className="mb-1 block text-sm font-medium text-gray-700"
                            htmlFor="localAccommodation"
                          >
                            Accommodation Details
                          </label>
                          <input
                            id="localAccommodation"
                            type="text"
                            value={localAccommodation}
                            onChange={(e) =>
                              setLocalAccommodation(e.target.value)
                            }
                            className="w-full rounded-lg border border-white/15 bg-white/5 px-3 py-2 text-sm text-[#1a1f28] placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-[#c4915f]"
                            placeholder="Enter accommodation details"
                          />
                        </div>
                      </div>
                    )}
                  </div>

                  {/* MEAL OPTIONS - FROM API */}
                  <div>
                    <h3 className="mb-3 text-sm font-semibold uppercase tracking-wide text-gray-700">
                      Meal Options
                    </h3>
                    <div className="mb-4 flex gap-3">
                      <button
                        onClick={() => setMealOption("with")}
                        className={`rounded-lg px-4 py-2 text-sm font-medium transition-colors duration-200 ${
                          mealOption === "with"
                            ? "bg-[#c4915f] text-[#1a1f28] shadow-lg shadow-[#c4915f]/30"
                            : "bg-white/10 text-gray-700 hover:bg-white/20"
                        }`}
                      >
                        With Meals
                      </button>
                      <button
                        onClick={() => setMealOption("without")}
                        className={`rounded-lg px-4 py-2 text-sm font-medium transition-colors duration-200 ${
                          mealOption === "without"
                            ? "bg-[#c4915f] text-[#1a1f28] shadow-lg shadow-[#c4915f]/30"
                            : "bg-white/10 text-gray-700 hover:bg-white/20"
                        }`}
                      >
                        Without Meals
                      </button>
                    </div>

                    {mealOption === "with" && (
                      <div className="rounded-xl border border-white/10 bg-white/5 p-4 text-[#1a1f28]">
                        <div className="mb-4">
                          <h4 className="mb-2 text-sm font-semibold uppercase tracking-wide text-gray-700">
                            Meal Type
                          </h4>
                          <div className="flex gap-3">
                            {["non-veg", "veg"].map((type) => (
                              <button
                                key={type}
                                onClick={() => setVegOption(type)}
                                className={`rounded-lg px-3 py-1 text-xs font-medium capitalize transition-colors duration-200 ${
                                  vegOption === type
                                    ? "bg-[#c4915f] text-[#1a1f28] shadow-lg shadow-[#c4915f]/30"
                                    : "border border-white/15 bg-white/5 text-gray-700 hover:bg-white/10"
                                }`}
                              >
                                {type.replace("-", " ")}
                              </button>
                            ))}
                          </div>
                        </div>

                        <div className="space-y-2">
                          {/* BREAKFAST - ITEMS FROM API */}
                          <div className="flex items-center justify-between rounded border border-white/10 bg-white/5 p-2 text-[#1a1f28]">
                            <div className="flex items-center">
                              <input
                                type="checkbox"
                                id="breakfast"
                                checked={includeBreakfast}
                                onChange={() =>
                                  setIncludeBreakfast(!includeBreakfast)
                                }
                                className="mr-2 h-5 w-5 rounded border-white/20 bg-transparent text-[#c4915f] focus:ring-[#c4915f]"
                              />
                              <label htmlFor="breakfast" className="font-medium">
                                Breakfast
                              </label>
                            </div>
                          </div>

                          {/* BREAKFAST MENU FROM API */}
                          {includeBreakfast && getBreakfastMenu().length > 0 && (
                            <div className="ml-8 mb-2 text-sm text-gray-600">
                              <div className="mb-1 font-semibold text-[#1a1f28]">
                                Select your breakfast items:
                              </div>
                              <ul className="space-y-2">
                                {getBreakfastMenu().map((item) => (
                                  <li
                                    key={item._id || item.name}
                                    className="flex items-start"
                                  >
                                    <input
                                      type="checkbox"
                                      id={`breakfast-${item._id || item.name}`}
                                      checked={selectedBreakfastItems.includes(
                                        item.name
                                      )}
                                      onChange={() =>
                                        handleBreakfastItemChange(item.name)
                                      }
                                      className="mt-1 mr-2 h-4 w-4 rounded border-white/20 bg-transparent text-[#c4915f] focus:ring-[#c4915f] flex-shrink-0"
                                    />
                                    <label 
                                      htmlFor={`breakfast-${item._id || item.name}`}
                                      className="flex-1 cursor-pointer"
                                    >
                                      <div className="flex items-center justify-between">
                                        <span className="font-medium text-[#1a1f28]">
                                          {item.name}
                                        </span>
                                        <span className="text-[#c4915f] font-semibold ml-2">
                                          +${item.price || 0}
                                        </span>
                                      </div>
                                      {item.description && (
                                        <div className="text-xs text-gray-500 mt-0.5">
                                          {item.description}
                                        </div>
                                      )}
                                      {item.isVegetarian && (
                                        <span className="inline-block mt-1 text-xs px-2 py-0.5 rounded bg-green-100 text-green-700">
                                          Vegetarian
                                        </span>
                                      )}
                                    </label>
                                  </li>
                                ))}
                                {/* EGGS OPTION FOR VEG */}
                                {vegOption === "veg" && (
                                  <li className="flex items-center">
                                    <input
                                      type="checkbox"
                                      id="includeEggs"
                                      checked={includeEggs}
                                      onChange={() =>
                                        setIncludeEggs(!includeEggs)
                                      }
                                      className="mr-2 h-4 w-4 rounded border-white/20 bg-transparent text-[#c4915f] focus:ring-[#c4915f]"
                                    />
                                    <label htmlFor="includeEggs">
                                      Eggs (any style){" "}
                                      <span className="text-[#c4915f]">
                                        +$1.5
                                      </span>
                                    </label>
                                  </li>
                                )}
                              </ul>
                            </div>
                          )}

                          {/* LUNCH - ITEMS FROM API */}
                          <div className="flex items-center justify-between rounded border border-white/10 bg-white/5 p-2 text-[#1a1f28]">
                            <div className="flex items-center">
                              <input
                                type="checkbox"
                                id="lunch"
                                checked={includeLunch}
                                onChange={() => setIncludeLunch(!includeLunch)}
                                className="mr-2 h-5 w-5 rounded border-white/20 bg-transparent text-[#c4915f] focus:ring-[#c4915f]"
                              />
                              <label htmlFor="lunch" className="font-medium">
                                Lunch
                              </label>
                            </div>
                          </div>

                          {/* LUNCH MENU FROM API */}
                          {includeLunch && getLunchMenu().length > 0 && (
                            <div className="ml-8 mb-2 text-sm text-gray-600">
                              <div className="mb-1 font-semibold text-[#1a1f28]">
                                Select your lunch items:
                              </div>
                              <ul className="space-y-2">
                                {getLunchMenu().map((item) => (
                                  <li
                                    key={item._id || item.name}
                                    className="flex items-start"
                                  >
                                    <input
                                      type="checkbox"
                                      id={`lunch-${item._id || item.name}`}
                                      checked={selectedLunchItems.includes(
                                        item.name
                                      )}
                                      onChange={() =>
                                        handleLunchItemChange(item.name)
                                      }
                                      className="mt-1 mr-2 h-4 w-4 rounded border-white/20 bg-transparent text-[#c4915f] focus:ring-[#c4915f] flex-shrink-0"
                                    />
                                    <label 
                                      htmlFor={`lunch-${item._id || item.name}`}
                                      className="flex-1 cursor-pointer"
                                    >
                                      <div className="flex items-center justify-between">
                                        <span className="font-medium text-[#1a1f28]">
                                          {item.name}
                                        </span>
                                        <span className="text-[#c4915f] font-semibold ml-2">
                                          +${item.price || 0}
                                        </span>
                                      </div>
                                      {item.description && (
                                        <div className="text-xs text-gray-500 mt-0.5">
                                          {item.description}
                                        </div>
                                      )}
                                      {item.isVegetarian && (
                                        <span className="inline-block mt-1 text-xs px-2 py-0.5 rounded bg-green-100 text-green-700">
                                          Vegetarian
                                        </span>
                                      )}
                                    </label>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          )}

                          {/* NO MEALS AVAILABLE MESSAGE */}
                          {mealOption === "with" &&
                            !includeBreakfast &&
                            !includeLunch &&
                            breakfastMenuItems.length === 0 &&
                            lunchMenuItems.length === 0 && (
                              <div className="py-4 text-center text-sm text-gray-600">
                                No meal options available for this package
                              </div>
                            )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </section>
              {/* 6. SUMMARY & BOOKING */}
              <section>
                <h2 className="text-2xl font-bold text-[#c4915f] mb-6 flex items-center">
                  <span className="bg-[#c4915f] text-[#1a1f28] rounded-full w-8 h-8 flex items-center justify-center mr-3">
                    6
                  </span>
                  Review Your Reservation
                </h2>

                <div className="mdc-card">
                  <div className="mdc-card-content">
                    <div className="mdc-card-grid">
                      {/* RESERVATION DETAILS */}
                      <div className="space-y-5">
                        <span className="mdc-chip">
                          <span
                            className="mdc-chip-icon"
                            aria-hidden="true"
                          ></span>
                          Reservation Details
                        </span>

                        <div className="mdc-surface">
                          <div className="mdc-list">
                            <div className="mdc-list-item">
                              <span className="mdc-list-label">Package</span>
                              <span className="mdc-list-value">
                                {selectedPackage.name}
                              </span>
                            </div>
                            <div className="mdc-list-item">
                              <span className="mdc-list-label">
                                Safari Type
                              </span>
                              <span className="mdc-list-value capitalize">
                                {reservationType}
                              </span>
                            </div>
                            <div className="mdc-list-item">
                              <span className="mdc-list-label">
                                National Park
                              </span>
                              <span className="mdc-list-value capitalize">
                                {selectedPackage.park}
                              </span>
                            </div>
                            {selectedPackage.block && (
                              <div className="mdc-list-item">
                                <span className="mdc-list-label">Block</span>
                                <span className="mdc-list-value">
                                  {selectedPackage.block}
                                </span>
                              </div>
                            )}
                            <div className="mdc-list-item">
                              <span className="mdc-list-label">Jeep Type</span>
                              <span className="mdc-list-value capitalize">
                                {jeepType.replace(/([A-Z])/g, " $1").trim()}
                              </span>
                            </div>
                            <div className="mdc-list-item">
                              <span className="mdc-list-label">Time Slot</span>
                              <span className="mdc-list-value capitalize">
                                {timeSlot}
                              </span>
                            </div>
                            <div className="mdc-list-item">
                              <span className="mdc-list-label">
                                Guide Option
                              </span>
                              <span className="mdc-list-value capitalize">
                                {guideOption.replace(/([A-Z])/g, " $1").trim()}
                              </span>
                            </div>
                            <div className="mdc-list-item">
                              <span className="mdc-list-label">
                                Visitor Type
                              </span>
                              <span className="mdc-list-value capitalize">
                                {visitorType}
                              </span>
                            </div>
                            <div className="mdc-list-item">
                              <span className="mdc-list-label">Meals</span>
                              <span className="mdc-list-value capitalize">
                                {mealOption === "with"
                                  ? `${vegOption}${
                                      includeEggs ? " with eggs" : ""
                                    }${
                                      includeBreakfast ? " + breakfast" : ""
                                    }${includeLunch ? " + lunch" : ""}`
                                  : "None"}
                              </span>
                            </div>
                            <div className="mdc-list-item">
                              <span className="mdc-list-label">
                                Number of People
                              </span>
                              <span className="mdc-list-value">{people}</span>
                            </div>
                            <div className="mdc-list-item">
                              <span className="mdc-list-label">Date</span>
                              <span className="mdc-list-value">
                                {reservationType === "private" && privateDate
                                  ? moment(privateDate).format("MMMM D, YYYY")
                                  : reservationType === "shared" &&
                                    sharedSelectedDate
                                  ? moment(sharedSelectedDate).format(
                                      "MMMM D, YYYY"
                                    )
                                  : "Not selected"}
                              </span>
                            </div>
                            {reservationType === "shared" && (
                              <div className="mdc-list-item">
                                <span className="mdc-list-label">
                                  Seat Number
                                </span>
                                <span className="mdc-list-value">
                                  {sharedSelectedSeat || "Not selected"}
                                </span>
                              </div>
                            )}
                            {fullName && (
                              <div className="mdc-list-item">
                                <span className="mdc-list-label">
                                  Customer Name
                                </span>
                                <span className="mdc-list-value">{fullName}</span>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* PRICE SUMMARY - ALL FROM API */}
                      <div className="space-y-5">
                        <span className="mdc-chip">
                          <span
                            className="mdc-chip-icon"
                            aria-hidden="true"
                          ></span>
                          Price Summary
                        </span>

                        <div className="mdc-price-card">
                          <div className="space-y-3">
                            {/* PRIVATE SAFARI PRICING */}
                            {reservationType === "private" && (
                              <>
                                <div className="mdc-price-item">
                                  <span>
                                    Jeep (
                                    {jeepType
                                      .replace(/([A-Z])/g, " $1")
                                      .trim()}
                                    ):
                                  </span>
                                  <span className="font-semibold">
                                    ${pricing.jeep[jeepType]?.[timeSlot] || 0}
                                  </span>
                                </div>
                                <div className="mdc-price-item">
                                  <span>
                                    Guide (
                                    {guideOption
                                      .replace(/([A-Z])/g, " $1")
                                      .trim()}
                                    ):
                                  </span>
                                  <span className="font-semibold">
                                    +${pricing.guide[guideOption] || 0}
                                  </span>
                                </div>
                                <p className="mdc-supporting-text text-right italic">
                                  Per person share: $
                                  {(
                                    ((pricing.jeep[jeepType]?.[timeSlot] || 0) +
                                      (pricing.guide[guideOption] || 0)) /
                                    people
                                  ).toFixed(2)}{" "}
                                  each
                                </p>
                              </>
                            )}

                            {/* SHARED SAFARI PRICING */}
                            {reservationType === "shared" && (
                              <div className="mdc-price-item">
                                <span>
                                  Shared Safari ({people} person
                                  {people > 1 ? "s" : ""}):
                                </span>
                                <span className="font-semibold">
                                  $
                                  {(pricing.shared[Math.min(people, 7)] || 0) *
                                    people}
                                </span>
                              </div>
                            )}

                            {/* TICKET PRICING - FROM API */}
                            <div className="mdc-price-item">
                              <span>
                                Tickets ({visitorType}, {people} person
                                {people > 1 ? "s" : ""}):
                              </span>
                              <span className="font-semibold">
                                +${getTicketPrice() * people}
                              </span>
                            </div>

                            {/* MEAL PRICING - FROM API */}
                            {mealOption === "with" && (
                              <>
                                {includeBreakfast &&
                                  selectedBreakfastItems.length > 0 && (
                                    <div className="mdc-price-item">
                                      <span>
                                        Breakfast ({vegOption}
                                        {vegOption === "veg" && includeEggs
                                          ? " + eggs"
                                          : ""}
                                        ):
                                      </span>
                                      <span className="font-semibold">
                                        +$
                                        {(
                                          (getBreakfastMenu()
                                            .filter((item) =>
                                              selectedBreakfastItems.includes(
                                                item.name
                                              )
                                            )
                                            .reduce(
                                              (sum, item) =>
                                                sum + (item.price || 0),
                                              0
                                            ) +
                                            (vegOption === "veg" && includeEggs
                                              ? 1.5
                                              : 0)) *
                                          people
                                        ).toFixed(2)}
                                      </span>
                                    </div>
                                  )}
                                {includeLunch &&
                                  selectedLunchItems.length > 0 && (
                                    <div className="mdc-price-item">
                                      <span>Lunch ({vegOption}):</span>
                                      <span className="font-semibold">
                                        +$
                                        {(
                                          getLunchMenu()
                                            .filter((item) =>
                                              selectedLunchItems.includes(
                                                item.name
                                              )
                                            )
                                            .reduce(
                                              (sum, item) =>
                                                sum + (item.price || 0),
                                              0
                                            ) * people
                                        ).toFixed(2)}
                                      </span>
                                    </div>
                                  )}
                              </>
                            )}
                          </div>

                          <div className="mdc-divider"></div>

                          {/* TOTAL PRICE */}
                          <div className="mdc-total">
                            <span className="mdc-total-label">Total Price</span>
                            <span className="mdc-total-value">
                              ${calculateTotal()}
                            </span>
                          </div>
                          <p className="mdc-supporting-text text-right">
                            All prices from {selectedPackage.name}
                          </p>
                        </div>

                        {/* BOOK NOW BUTTON */}
                        <div className="space-y-3">
                          <button
                            className="mdc-primary-button"
                            onClick={() => {
                              if (reservationType === "shared") {
                                setShowBookingSection(true);
                              } else {
                                handleBookNow();
                              }
                            }}
                            disabled={!pricing}
                          >
                            <svg
                              className="h-5 w-5"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M5 13l4 4L19 7"
                              ></path>
                            </svg>
                            {pricing
                              ? "Confirm & Book Now"
                              : "Loading pricing..."}
                          </button>

                          {!pricing && (
                            <p className="mdc-button-note">
                              Please wait while we load pricing information
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        )}

        {/* NO PACKAGE SELECTED MESSAGE */}
        {!showPackageSelector && !selectedPackage && (
          <div className="rounded-3xl border border-white/10 bg-white/5 p-12 text-center text-[#1a1f28] shadow-2xl shadow-black/30 backdrop-blur">
            <svg
              className="mx-auto mb-4 h-16 w-16 text-gray-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <h3 className="mb-2 text-xl font-semibold">
              No Package Selected
            </h3>
            <p className="mb-6 text-gray-600">
              Please select a package to continue with your booking
            </p>
            <button
              onClick={() => setShowPackageSelector(true)}
              className="rounded-lg bg-[#c4915f] px-6 py-3 font-semibold text-[#1a1f28] shadow-lg shadow-[#c4915f]/30 transition-transform duration-200 hover:-translate-y-0.5 hover:bg-[#b37f4a]"
            >
              Browse Packages
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Packages;